import React from 'react'
import styles from './styles.css'
import PropTypes from 'prop-types'
import MdPeople from 'react-icons/lib/md/people'

export default class FeaSigners extends React.Component {
  static propTypes = {
    verifyDocument: PropTypes.object
  }
  state = {}
  renderFeaSigners() {
    if(this.props.verifyDocument.feaSigners)
      return this.props.verifyDocument.feaSigners.map(feaSigner => {
        return (
          <div className="row" key={feaSigner.email}>
            <div className={styles.Email}>{feaSigner.email}</div>
            <div className={styles.Signer}>{feaSigner.name}</div>
          </div>
        )
      })
  }

  render() {
    if (!this.props.verifyDocument) return
    if (this.props.verifyDocument.documentStatus.status === 'personal') return
    return (
      <div className="section">
        <div className="header">
          <div className="row">
            <div className={styles.Icon}>
              <MdPeople size={'30'} />
            </div>
            <div className={styles.Title}>
              <h3>Firmas Electrónicas Avanzadas</h3>
            </div>
          </div>
        </div>
        <div className="content">{this.renderFeaSigners()}</div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/DocumentVerify/Main/Verify/FeaSigners/index.js